import { Suspense } from 'react'
import { lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { IRoute } from './types'
import { Helmet } from 'react-helmet-async'
import { getIsPhone } from "../utils";
// 导航页
const App = lazy(() => import('../App'))
const GameRecharge = lazy(() => import('../container/recharge/index'))

// 路由配置
const routes: Array<IRoute> = [
    { path: '/', name: 'app', element: <App /> , children:[
        { path: '/', name: 'list', element: <Navigate to='/z' /> },
        { path: '/:product', name: 'rechare', element: <GameRecharge />, children: [] },
        
    ] }
]

 // 是否手机访问页面
 const isPhone = getIsPhone()

const ViewRouter = () => {
    return (
        <>
            <Helmet>
                {
                    !isPhone && <link rel='stylesheet' href={'static/css/style.css'}></link>
                }
            </Helmet>
            <Suspense fallback={<></>}>
                <Routes>
                    {
                        routes.map((item, index) => {
                            return (
                                <Route key={index} path={item.path} element={item.element}>
                                    {
                                        item.children?.length && item.children.map(child => {
                                            return <Route key={item.name} path={child.path} element={child.element}></Route>
                                        })
                                    }
                                </Route>
                            )
                        })
                    }
                </Routes>
                
            </Suspense>
        </>
    )
}

export default ViewRouter